import { getTimeFromMin } from "../../../helpers";
import { animate, useMotionValue, useTransform, motion } from "framer-motion";
import { useEffect } from "react";

interface AnimatedTimeProps {
	valueSeconds: number;
	delay?: number;
	duration?: number;
}

export const AnimatedTime = ({ valueSeconds, delay = 0.45, duration = 0.8 }: AnimatedTimeProps) => {
	const safeValueSeconds = Math.max(0, valueSeconds);

	const motionValue = useMotionValue(0);
	const formattedTime = useTransform(motionValue, (latest) => {
		return getTimeFromMin(Math.round(latest / 60));
	});

	useEffect(() => {
		const controls = animate(motionValue, safeValueSeconds, {
			delay,
			duration,
			ease: [0.16, 1, 0.3, 1],
		});
		return () => controls.stop();
	}, [motionValue, safeValueSeconds, delay, duration]);

	return <motion.span>{formattedTime}</motion.span>;
};
